import { Flex, IconButton, Tooltip } from '@radix-ui/themes'
import { Link } from '@remix-run/react'
import { type TFunction } from 'i18next'
import * as React from 'react'
import { RxPlus } from 'react-icons/rx'
import { type Locale } from '~/models/locale'
import { type PROFILE_ADDRESSES_INDEX_I18NEXT } from '~/routes/($lang).profile.addresses._index/index.component'

type HeaderProps = {
	t: TFunction<
		PROFILE_ADDRESSES_INDEX_I18NEXT.routeProfileAddressesIndex,
		undefined
	>
	locale: Locale
	pagerViewCreated: string
}

const Header: React.FC<HeaderProps> = ({ t, locale, pagerViewCreated }) => {
	return (
		<Flex justify="end">
			<Tooltip content={t('items.button.createNewAddress')}>
				<Link
					to={`/${locale}/profile/addresses/create${pagerViewCreated}`}
					prefetch="viewport"
				>
					<IconButton radius="full" size="3" mt="4">
						<RxPlus size="1.2em" />
					</IconButton>
				</Link>
			</Tooltip>
		</Flex>
	)
}

export { Header }
